import React from 'react'
import classes from './Input.module.css'
import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles'

const CssTextField = withStyles({
  root: {
    '& label': {
      color: '#604f93'
    },
    '& label.Mui-focused': {
      color: '#604f93'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#604f93'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#604f93'
      },
      '&:hover fieldset': {
        borderColor: '#604f93'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#604f93'
      }
    }
  }
})(TextField)

export default props => (
  <div className={classes.InputWrapper}>
    <CssTextField
      required={props.required}
      id={props.id}
      label={props.label}
      type={props.type}
      variant="outlined"
      placeholder={props.placeholder}
      name={props.id}
      InputLabelProps={{
        shrink: true
      }}
      className={classes.Input}
      onChange={props.chageHandler}
      error={props.touched ? (!props.valid ? true : false) : false}
      helperText={
        props.touched ? (!props.valid ? props.helperText : null) : null
      }
      multiline={props.multiline}
      rows="5"
      value={props.value}
      disabled={props.disabled}
    />
  </div>
)
